// extracted by mini-css-extract-plugin
export var container = "files-to-download-module--container--ypoar";
export var error = "files-to-download-module--error--6nB+J";
export var list = "files-to-download-module--list--hX4-c";
export var loader = "files-to-download-module--loader--wqsqa";
export var lowOpacity = "files-to-download-module--lowOpacity--vsFfe";
export var noContent = "files-to-download-module--no-content--cTVzX";
export var paginationRow = "files-to-download-module--pagination-row--PU4kA";